import React from "react";
import { useFormContext } from "react-hook-form";
import { Input } from "../ui/Input";
import { Label } from "../ui/Label";

export function OwnersAndReferencesStep() {
  const { register } = useFormContext();

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">
          Company Officers/Owner Names & Titles
        </h3>
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-3 gap-4 pb-4 border-b border-slate-100 last:border-0"
          >
            <div className="space-y-2">
              <Label>Name & Title</Label>
              <Input {...register(`officers.${index}.nameAndTitle`)} />
            </div>
            <div className="space-y-2">
              <Label>Birth Date</Label>
              <Input type="date" {...register(`officers.${index}.birthDate`)} />
            </div>
            <div className="space-y-2">
              <Label>City of Residence</Label>
              <Input {...register(`officers.${index}.cityOfResidence`)} />
            </div>
          </div>
        ))}
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">
          Credit/Trade References (Must list three)
        </h3>
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            className="grid grid-cols-1 md:grid-cols-3 gap-4 pb-4 border-b border-slate-100 last:border-0"
          >
            <div className="space-y-2">
              <Label>Supplier Name</Label>
              <Input {...register(`tradeReferences.${index}.supplierName`)} />
            </div>
            <div className="space-y-2">
              <Label>Telephone #</Label>
              <Input
                type="tel"
                {...register(`tradeReferences.${index}.telephone`)}
              />
            </div>
            <div className="space-y-2">
              <Label>Email Address</Label>
              <Input
                type="email"
                {...register(`tradeReferences.${index}.email`)}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="space-y-4">
        <h3 className="text-lg font-medium border-b pb-2">Bank Reference</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-2 md:col-span-2">
            <Label htmlFor="bankName">Name & Branch</Label>
            <Input id="bankName" {...register("bankReference.nameAndBranch")} />
          </div>
          <div className="space-y-2 md:col-span-2">
            <Label htmlFor="bankAddress">Address</Label>
            <Input id="bankAddress" {...register("bankReference.address")} />
          </div>
          <div className="space-y-2">
            <Label htmlFor="bankContact">Contact Person</Label>
            <Input
              id="bankContact"
              {...register("bankReference.contactPerson")}
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="bankPhone">Telephone</Label>
            <Input
              id="bankPhone"
              type="tel"
              {...register("bankReference.telephone")}
            />
          </div>
          <div className="space-y-2 md:col-span-2">
            <Label htmlFor="bankEmail">Email</Label>
            <Input
              id="bankEmail"
              type="email"
              {...register("bankReference.email")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
